import { render } from "./WelcomePopup.vue?vue&type=template&id=2cd994b9&scoped=true"
import script from "./WelcomePopup.vue?vue&type=script&lang=js"
export * from "./WelcomePopup.vue?vue&type=script&lang=js"

import "./WelcomePopup.vue?vue&type=style&index=0&id=2cd994b9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd994b9"]])

export default __exports__